import React from 'react'

export default function FaceFeature({ scale, verticalOffset }) {
  const transformOrigin = '20 9'
  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M9.35992 17.84C14.0102 17.84 17.7799 14.0702 17.7799 9.42C17.7799 4.76976 14.0102 1 9.35992 1C4.70969 1 0.939941 4.76976 0.939941 9.42C0.939941 14.0702 4.70969 17.84 9.35992 17.84Z"
        stroke="#644534"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M31.4898 17.84C36.14 17.84 39.9098 14.0702 39.9098 9.42C39.9098 4.76976 36.14 1 31.4898 1C26.8396 1 23.0698 4.76976 23.0698 9.42C23.0698 14.0702 26.8396 17.84 31.4898 17.84Z"
        stroke="#644534"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M17.79 9.41993C17.79 9.41993 20.35 7.94993 23.07 9.41993"
        stroke="#644534"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
